module.exports = __webpack_public_path__ + "aaf99affc20fee2b11842eac72fb4386.png";